import React from 'react';
import ProjectsHero from './sections/ProjectsHero';
import ProjectShowcase from './sections/ProjectShowcase';
import ProjectsCTA from './sections/ProjectsCTA';

const ProjectsPage = () => {
  return (
    <main className="min-h-screen bg-black">
      <ProjectsHero />
      <ProjectShowcase />
      <ProjectsCTA />
    </main>
  );
};

export default ProjectsPage;